import { render, staticRenderFns } from "./rankingSupplier.vue?vue&type=template&id=388662e7&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./rankingSupplier.vue?vue&type=style&index=0&id=388662e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388662e7",
  null
  
)

export default component.exports